import { AssetDownloadLink, AssetReference } from '@opallabs/cassini'
import { formatFilesize } from '@opallabs/lambda'
import {
  Button,
  ButtonIconPosition,
  CaptionText,
  Icon,
  Tooltip,
} from '@opallabs/lapidary'
import * as styles from './styles'

interface Props {
  asset: AssetReference
  onExpandAsset: (id?: number) => void
  onRemoveAsset: (id?: number) => void
}

export const FileAsset: React.FC<Props> = ({
  asset,
  onExpandAsset,
  onRemoveAsset,
}) => {
  const formatFileButtonText = (name: string) =>
    name.length > 50 ? `${name.slice(0, 50)}...` : name

  return (
    <div css={styles.fileWrapper}>
      <div css={styles.fileSectionWrapper}>
        <Tooltip content="View File" side="bottom" zIndex={9999}>
          <Button
            buttonText={formatFileButtonText(
              asset.title || asset.filename || ''
            )}
            icon={<Icon glyph="gem-file" ariaHidden />}
            iconPosition={ButtonIconPosition.leading}
            name="file name"
            onClick={() => onExpandAsset(asset.id)}
            variant="ghost"
          />
        </Tooltip>
        <Tooltip content="Remove" side="bottom" zIndex={9999}>
          <Button
            name="remove"
            hideButtonText
            icon={<Icon glyph="gem-trash" />}
            onClick={() => onRemoveAsset(asset.id)}
            variant="ghost"
          />
        </Tooltip>
      </div>
      <div css={styles.fileSectionWrapper}>
        <CaptionText>{formatFilesize(asset.filesize)}</CaptionText>
        <AssetDownloadLink assetReference={asset}>
          <Tooltip content="Download" side="bottom" zIndex={9999}>
            <Button
              name="download"
              hideButtonText
              icon={<Icon glyph="gem-download" />}
              style={{ marginLeft: 2 }}
              variant="ghost"
            />
          </Tooltip>
        </AssetDownloadLink>
      </div>
    </div>
  )
}
